module.exports = __webpack_public_path__ + "img/MDI-notebook-check-outline.772048a3.svg";